'use client'
import { useRouter } from '@/i18n/navigation'
import { Modal } from 'rsuite'

type Props = {
  open: any
  handleClose: () => void
  children: React.ReactNode
}

const CustomFullModal = ({ open, handleClose, children }: Props) => {
  const router = useRouter()

  return (
    <Modal size={'full'} open={open} onClose={handleClose}>
      <button
        onClick={() => {
          router.back()
        }}
      >
        Close modal
      </button>
      Modal header
      {children}
    </Modal>
  )
}

export default CustomFullModal
